export class SurveyDateFilters {
    selectedFrom: Date | null = null
    selectedTo: Date | null = null
}

